<template>
  <div
    class="microlearning-video-with-generate-inspection-bar"
    :class="{
      'microlearning-video-with-generate-inspection-bar--mdp452-source': isMdp452SourceStyle,
    }"
  >
    <div class="microlearning-video-with-generate-inspection-bar__label">
      <span class="microlearning-video-with-generate-inspection-bar__label-text">{{
        sectionTitle
      }}</span>
      <div class="microlearning-video-with-generate-inspection-bar__label-underline" />
    </div>
    <div v-if="!disabled" class="microlearning-video-with-generate-inspection-bar__actions">
      <AddORAskIQButton
        :showAddButton="false"
        :showAIButton="true"
        :label="generateButtonLabel"
        :empLabel="generateButtonLabel"
        @addAI="handleAIClick"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import AddORAskIQButton from "@components/AddORAskIQButton/AddORAskIQButton.vue";

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  /** Left tab label (legacy default: "Microlearning Video") */
  sectionTitle: {
    type: String,
    default: "Microlearning Video",
  },
  /** IQ button copy (legacy default: "Generate Inspection") */
  generateButtonLabel: {
    type: String,
    default: "Generate Inspection",
  },
});

const isMdp452SourceStyle = computed(() => props.sectionTitle === "Source Video");

const emit = defineEmits(["suggest-instructions"]);

const handleAIClick = () => {
  emit("suggest-instructions");
};
</script>

<style scoped>
.microlearning-video-with-generate-inspection-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 12px;
  width: 100%;
}

/* idea-MDP-452: "Source Video" + long CTA (design: match checkpoint edit v2) */
.microlearning-video-with-generate-inspection-bar--mdp452-source {
  flex-wrap: wrap;
  row-gap: 10px;
  align-items: center;
}

.microlearning-video-with-generate-inspection-bar--mdp452-source
  .microlearning-video-with-generate-inspection-bar__actions {
  flex: 1 1 auto;
  min-width: 0;
  justify-content: flex-end;
}

.microlearning-video-with-generate-inspection-bar--mdp452-source :deep(.add-ask-iq-button) {
  min-width: 0;
  max-width: 100%;
  width: auto;
  height: auto !important;
  min-height: 40px;
  white-space: normal;
  text-align: left;
  padding: 10px 12px 10px 12px !important;
}

.microlearning-video-with-generate-inspection-bar--mdp452-source :deep(.add-ask-label) {
  text-transform: none;
  font-size: 14px;
  line-height: 20px;
  white-space: normal;
  text-align: left;
}

.microlearning-video-with-generate-inspection-bar__label {
  position: relative;
  flex-shrink: 0;
}

.microlearning-video-with-generate-inspection-bar__label-text {
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #7f56d9;
}

.microlearning-video-with-generate-inspection-bar__label-underline {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -7px;
  height: 2px;
  background-color: #7f56d9;
}

.microlearning-video-with-generate-inspection-bar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
</style>
